export default __webpack_public_path__ + "static/media/The Cloudscar.fa8e4177.jpg";